import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-cash-confirm-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <div class="cc-dialog">
      <div class="cc-header">
        <h2 class="cc-title">
          <span class="material-icons" aria-hidden="true">payments</span>
          {{ 'ticketOffice.cashConfirm.title' | translate }}
        </h2>
      </div>

      <div class="cc-body">
        <div *ngIf="recipientName" class="cc-recipient">
          <span class="material-icons cc-recipient__icon" aria-hidden="true">badge</span>
          <div class="cc-recipient__text">
            <span class="cc-recipient__label">{{
              'ticketOffice.cashConfirm.recipient' | translate
            }}</span>
            <span class="cc-recipient__name">{{ recipientName }}</span>
            <span *ngIf="recipientDetail" class="cc-recipient__detail">{{ recipientDetail }}</span>
          </div>
        </div>
        {{ 'ticketOffice.cashConfirm.message' | translate }}
      </div>

      <div class="cc-footer">
        <button type="button" class="cc-btn cc-btn--cancel" (click)="cancel()">
          {{ 'ticketOffice.cashConfirm.cancel' | translate }}
        </button>
        <button type="button" class="cc-btn cc-btn--confirm" ngbAutofocus (click)="confirm()">
          {{ 'ticketOffice.cashConfirm.confirm' | translate }}
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      :host-context(html.theme-light) {
        --brand-accent: var(--color-accent);
      }

      .cc-dialog {
        display: flex;
        flex-direction: column;
        background: var(--modal-bg, var(--color-surface));
        color: var(--color-text);
        border-radius: 12px;
        overflow: hidden;
      }

      .cc-header {
        padding: 18px 22px;
        border-bottom: 1px solid var(--border-color);
      }

      .cc-title {
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 0;
        font-size: 20px;
        font-weight: 600;

        .material-icons {
          color: var(--brand-accent);
        }
      }

      .cc-body {
        padding: 22px;
        font-size: 15px;
        line-height: 1.4;
      }

      .cc-recipient {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;
        padding: 12px 14px;
        border-radius: 10px;
        background: var(--menu-hover-bg);
        border: 1px solid var(--border-color);
        border-left: 3px solid var(--brand-accent);
      }

      .cc-recipient__icon {
        color: var(--brand-accent);
        font-size: 28px;
      }

      .cc-recipient__text {
        display: flex;
        flex-direction: column;
        min-width: 0;
      }

      .cc-recipient__label {
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: var(--color-text-muted, #888);
      }

      .cc-recipient__name {
        font-size: 17px;
        font-weight: 700;
        word-break: break-word;
      }

      .cc-recipient__detail {
        font-size: 13px;
        color: var(--color-text-muted, #888);
        margin-top: 1px;
      }

      .cc-footer {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        padding: 16px 22px;
        border-top: 1px solid var(--border-color);
      }

      .cc-btn {
        height: 40px;
        padding: 0 18px;
        border-radius: 100px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        border: 1px solid var(--border-color);
      }

      .cc-btn--cancel {
        background: transparent;
        color: var(--color-text);

        &:hover {
          background: var(--menu-hover-bg);
        }
      }

      .cc-btn--confirm {
        background: var(--brand-accent);
        color: var(--menu-active-text);
        border-color: var(--brand-accent);

        &:hover {
          opacity: 0.9;
        }
      }
    `,
  ],
})
export class CashConfirmDialogComponent {
  recipientName?: string;
  recipientDetail?: string;

  private decided = false;

  constructor(public activeModal: NgbActiveModal) {}

  // Enter = isto kao klik na "Potvrdi"
  @HostListener('document:keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent): void {
    event.preventDefault();
    this.confirm();
  }

  confirm(): void {
    if (this.decided) return;
    this.decided = true;
    this.activeModal.close(true);
  }

  cancel(): void {
    if (this.decided) return;
    this.decided = true;
    this.activeModal.dismiss('cancel');
  }
}
